"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactModal = _interopRequireDefault(require("react-modal"));

var _classnames = _interopRequireDefault(require("classnames"));

var _image = _interopRequireDefault(require("../contentful-views/image"));

var _layeredDialog = require("./layered-dialog.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultModalStyles = {
  content: {
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    background: "none"
  },
  overlay: {
    backgroundColor: "none",
    border: "none",
    borderRadius: "0"
  }
};

var LayeredDialog = function LayeredDialog(_ref) {
  var _backgroundImage$fiel, _backgroundImage$fiel2;

  var backgroundColor = _ref.backgroundColor,
      backgroundImage = _ref.backgroundImage,
      backgroundPattern = _ref.backgroundPattern,
      children = _ref.children,
      className = _ref.className,
      overlayClassName = _ref.overlayClassName,
      isOpen = _ref.isOpen,
      offsetHorizontal = _ref.offsetHorizontal,
      offsetVertical = _ref.offsetVertical,
      onRequestClose = _ref.onRequestClose,
      overlayColor = _ref.overlayColor,
      reactRootSelector = _ref.reactRootSelector,
      modalStyles = _ref.modalStyles;
  (0, _react.useEffect)(function () {
    // Needed for accessibility.
    if (reactRootSelector) {
      _reactModal["default"].setReactRoot(reactRootSelector);
    }
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_reactModal["default"], {
    className: (0, _classnames["default"])("LayeredDialog", className),
    overlayClassName: (0, _classnames["default"])("LayeredDialogOverlay", overlayClassName),
    isOpen: isOpen,
    onRequestClose: onRequestClose,
    style: _objectSpread(_objectSpread({}, defaultModalStyles), modalStyles)
  }, /*#__PURE__*/_react["default"].createElement(_layeredDialog.BackgroundLayer, {
    offsetHorizontal: offsetHorizontal,
    offsetVertical: offsetVertical,
    backgroundColor: backgroundColor,
    backgroundImage: backgroundPattern,
    backgroundImagePosition: "alignLeftTop",
    showOverlay: false
  }, /*#__PURE__*/_react["default"].createElement(_layeredDialog.BackgroundImageWrapper, null, backgroundImage !== null && backgroundImage !== void 0 && (_backgroundImage$fiel = backgroundImage.fields) !== null && _backgroundImage$fiel !== void 0 && (_backgroundImage$fiel2 = _backgroundImage$fiel.file) !== null && _backgroundImage$fiel2 !== void 0 && _backgroundImage$fiel2.url ? /*#__PURE__*/_react["default"].createElement(_layeredDialog.BgImage, null, /*#__PURE__*/_react["default"].createElement(_image["default"], {
    media: backgroundImage
  })) : null)), /*#__PURE__*/_react["default"].createElement(_layeredDialog.ContentLayer, {
    offsetHorizontal: offsetHorizontal,
    offsetVertical: offsetVertical
  }, children));
};

LayeredDialog.propTypes = {
  backgroundColor: _propTypes["default"].string,
  backgroundImage: _propTypes["default"].shape({
    fields: _propTypes["default"].shape({}),
    sys: _propTypes["default"].shape({})
  }),
  backgroundPattern: _propTypes["default"].string,
  backgroundImagePosition: _propTypes["default"].string,
  backgroundRepeat: _propTypes["default"].string,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired,
  isOpen: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  overlayClassName: _propTypes["default"].string,
  onRequestClose: _propTypes["default"].func,
  offsetHorizontal: _propTypes["default"].number,
  offsetVertical: _propTypes["default"].number,
  overlayColor: _propTypes["default"].string,
  reactRootSelector: _propTypes["default"].string,
  modalStyles: _propTypes["default"].shape(_reactModal["default"].defaultStyles)
};
LayeredDialog.defaultProps = {
  backgroundColor: "magic.base",
  backgroundImage: {},
  backgroundPattern: null,
  backgroundImagePosition: "alignLeftTop",
  backgroundRepeat: null,
  isOpen: false,
  className: null,
  overlayClassName: null,
  onRequestClose: null,
  offsetHorizontal: 120,
  offsetVertical: 10,
  overlayColor: "#FDFDFD",
  reactRootSelector: null,
  modalStyles: {}
};
var _default = LayeredDialog;
exports["default"] = _default;